export default __webpack_public_path__ + "static/media/license-plate.13a868ff.svg";